import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  border-bottom: 1px solid #f9f9f9;
  font-family: 'Oswald';
  padding: 8px;

  svg:hover {
    cursor: pointer;
  }
`;

export const RosterContent = styled.div`
  background-color: ${white};
  color: ${darkgrey};
  height: 100%;

  .react-autosuggest__container {
    overflow-y: hidden;
  }

  .react-autosuggest__input {
    width: 90%;
    border: none;

    &:focus {
      outline: none;
    }
  }

  ul.react-autosuggest__suggestions-list {
    list-style: none;
    padding: 0;
    height: 100%;
    margin-bottom: 0;

    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3.5px;
    }
    &::-webkit-scrollbar-thumb {
      background-image: linear-gradient(179deg, ${darkgrey}, rgba(65, 65, 65, 0.82));
      border-radius: 3.5px;
    }

    .react-autosuggest__suggestion--highlighted {
      box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
    }
  }
`;

export const Player = styled.div`
  height: 47px;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  padding: 0 15px;

  &:hover {
    cursor: pointer;
  }
`;

export const NoPlayers = styled.div`
  padding: 15px;
  color: #a0a0a0;
  font-size: 13px;
`;

export const BaseRosterWrapper = styled.div`
  position: absolute;
  padding: 32px 20px 20px;
  width: 98%;
  height: 93%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  z-index: 1;
`;
